import React, { Component, PropsWithChildren } from 'react';

/**
 * Wrapper for the bottom of a Modal to maintain appropriate Modal structure
 */
export class ModalFooter extends Component<PropsWithChildren> {
  public render() {
    return <div className={'modal-footer'}>{this.props.children}</div>;
  }
}

export default ModalFooter;
